import { Link } from 'gatsby';
import React, { Suspense } from 'react';

const ReactMarkdown = React.lazy(() => import('react-markdown'));

type Props = {
  caption: string;
};

const isExternalLink = (url = '') => {
  return url.startsWith('http') && !url.includes('hem.com');
};

export const ImageCaption: React.FC<Props> = ({ caption }): JSX.Element => {
  return (
    <Suspense
      fallback={
        <figcaption className="px-1 pb-1 pt-0.5">
          <p className="text-sm text-black-600">{caption}</p>
        </figcaption>
      }
    >
      <figcaption className="px-1 pb-1 pt-0.5">
        <ReactMarkdown
          components={{
            p: ({ children }) => (
              <p className="text-sm text-black-600">{children}</p>
            ),
            a: ({ href, children }) => {
              if (isExternalLink(href)) {
                return (
                  <a href={href} target="_blank" rel="noopener">
                    {children}
                  </a>
                );
              }
              return <Link to={href}>{children}</Link>;
            },
          }}
        >
          {caption}
        </ReactMarkdown>
      </figcaption>
    </Suspense>
  );
};
